<template>
  <a
    class="site_button"
    :class="[theme, type]"
    :href="parsedLink.url"
    :target="parsedLink.target"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
    ref="site_button"
  >
    <span v-html="button_label ? button_label : parsedLink.title"></span>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.811"
      height="15.811"
      viewBox="0 0 15.811 15.811"
      class="external_link_icon"
      v-if="
        parsedLink.target === '_blank' ||
        button_link.target === '_blank' ||
        target === '_blank'
      "
    >
      <g id="External-Link-Icon" transform="translate(0.75 1.061)">
        <path
          id="Path_276"
          data-name="Path 276"
          d="M16.167,14.444v4.667a1.556,1.556,0,0,1-1.556,1.556H6.056A1.556,1.556,0,0,1,4.5,19.111V10.556A1.556,1.556,0,0,1,6.056,9h4.667"
          transform="translate(-4.5 -6.667)"
          fill="none"
          stroke="#232350"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
        <path
          id="Path_277"
          data-name="Path 277"
          d="M22.5,4.5h4.667V9.167"
          transform="translate(-13.167 -4.5)"
          fill="none"
          stroke="#232350"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
        <path
          id="Path_278"
          data-name="Path 278"
          d="M15,13.056,23.556,4.5"
          transform="translate(-9.556 -4.5)"
          fill="none"
          stroke="#232350"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
      </g>
    </svg>
  </a>
</template>

<script>
import Close from '../../images/close.svg';
import Open from '../../images/menu.svg';

export default {
  data() {
    return {
      button_label: this.label,
      button_link: this.link,
      hovered: false,
      open: Open,
      close: Close,
    };
  },

  props: {
    link: {},
    label: {},
    target: {},
    theme: {
      default: 'light',
    },
    type: {
      default: 'normal',
    },
  },

  computed: {
    parsedLink() {
      if (typeof this.link === 'object' && this.link !== null) {
        return this.link;
      } else if (!Array.isArray(this.link)) {
        return JSON.parse(this.link);
      } else {
        return null;
      }
    },
  },

  watch: {
    link() {
      this.button_link = this.link;
    },
  },

  methods: {
    checkEmpty(e) {
      if (this.button_link.url === '#') {
        // this.$refs.site_button.removeAttribute('href');
        e.preventDefault();
      }
    },
  },

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button {
  display: inline-flex;
  padding: 0 24px;
  transition: 0.2s ease all;
  text-decoration: none;
  justify-content: flex-start;
  position: relative;
  background: transparent;
  align-items: center;
  text-decoration: none;
  background: var(--orange);
	height: 40px;

  span {
    color: var(--white);
		font-weight: normal;
  }

  .external_link_icon {
    margin-left: 8px;

    line,
    path {
      stroke: var(--navy);
      transition: 0.2s ease all;

      g {
        stroke: var(--navy);
        transition: 0.2s ease all;
      }
    }
  }

  @media (hover) {
    &:hover {
      transition: 0.2s ease all;
      cursor: pointer;
      background: var(--purple);

      span {
        transition: 0.2s ease all;
        color: var(--white);
      }

      &:before {
        transform: scaleX(1);
      }

      .external_link_icon {
        margin-left: 8px;

        line,
        path {
          stroke: var(--orange);
          transition: 0.2s ease all;

          g {
            stroke: var(--orange);
            transition: 0.2s ease all;
          }
        }
      }
    }
  }

  &:disabled {
    opacity: 0.5;
  }

  span {
    font: normal normal normal 14px/20px var(--primary-font-family);
    text-transform: uppercase;
    transition: 0.2s ease all;
    margin-right: 0;
    position: relative;
    z-index: 10;
  }

  img {
    display: flex;
    max-width: 24px;
    max-height: 12px;
    margin-left: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/PrimaryButton.vue